module.exports = __webpack_public_path__ + "static/media/YF47_0.e157e1f1.jpg";